var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWritingAssistantIcon = function SvgWritingAssistantIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.63,
    height: 26.419,
    viewBox: "0 0 31.63 26.419",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 8.559,
    y: 21.221,
    width: 13.824,
    height: 5.198,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.29
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 9.398,
    y: 8.306,
    width: 11.559,
    height: 14.411,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.29
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8014ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1367"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 184",
    d: "M4.308 23.93c-2.249-1-2.082-3.295-2.1-6.018a18.532 18.532 0 0 1 3.151-9.261 4.467 4.467 0 0 1 3.464-2.093c2.051-.167 3.314 1.256 6.767 1.256s5.14-1.406 7.044-1.256a4.147 4.147 0 0 1 3.532 2.094 17.337 17.337 0 0 1 3.153 8.731c-.028 2.657-.142 5.685-2.1 6.547a34.262 34.262 0 0 1-11.628 2.27 30.5 30.5 0 0 1-11.283-2.27zm25.339-8.256s-.22-.808-.466-1.682-.407-1.375-.519-1.794c-.241-.9.075-1.636.985-1.636s1.983.73 1.983 1.636v3.2a1.145 1.145 0 0 1-1.095 1.27c-.473-.004-.888-.994-.888-.994zM0 15.395V12.2c0-.906 1.073-1.636 1.983-1.636s1.227.739.985 1.636c-.113.419-.273.92-.52 1.794s-.465 1.682-.465 1.682-.415.991-.888.991A1.145 1.145 0 0 1 0 15.395zM15.342 6.8 14.8 4.737l-.424-1.6a1.573 1.573 0 1 1 .986-.247l.463 1.754.568 2.156a.525.525 0 0 1-1.051 0z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21002",
    d: "M.788 0A21.952 21.952 0 0 0 5.53.628 18.625 18.625 0 0 0 10.036 0a.785.785 0 1 1 0 1.57 18.625 18.625 0 0 1-4.506.63 21.952 21.952 0 0 1-4.742-.63.785.785 0 1 1 0-1.57z",
    transform: "translate(10.06 21.718)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21003",
    d: "M19.111 15 13 20.706h2.449l3.662-3.419zm-3.662 11.411 6.111-5.706h-2.449l-3.662 3.419z",
    transform: "translate(-2.1 -6.192)",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWritingAssistantIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WritingAssistantIcon.8c39101b.svg";
export { ForwardRef as ReactComponent };